module.exports = require("../../plugins/PluginInfo.vue");